import { create } from "zustand";

const MAX_EVENTS = 300;

export interface ResumeDebugEvent {
  id: number;
  ts: number;
  type: string;
  data?: unknown;
}

interface ResumeDebugStoreState {
  enabled: boolean;
  events: ResumeDebugEvent[];
  latestSttOutput: string | null;
  latestTtsOutput: string | null;
  setEnabled: (enabled: boolean) => void;
  setLatestSttOutput: (text: string | null) => void;
  setLatestTtsOutput: (text: string | null) => void;
  addEvent: (type: string, data?: unknown) => void;
  clearEvents: () => void;
}

function serializeDebugData(data: unknown): unknown {
  if (data === undefined) {
    return undefined;
  }

  try {
    return JSON.parse(
      JSON.stringify(data, (_key, value) => {
        if (value instanceof Set) {
          return Array.from(value);
        }
        if (typeof value === "function") {
          return "[function]";
        }
        return value;
      }),
    );
  } catch {
    return String(data);
  }
}

export const useResumeDebugStore = create<ResumeDebugStoreState>((set) => ({
  enabled: false,
  events: [],
  latestSttOutput: null,
  latestTtsOutput: null,
  setEnabled: (enabled: boolean) => set({ enabled }),
  setLatestSttOutput: (text) => set({ latestSttOutput: text }),
  setLatestTtsOutput: (text) => set({ latestTtsOutput: text }),
  addEvent: (type: string, data?: unknown) =>
    set((state) => {
      const next: ResumeDebugEvent = {
        id: Date.now() + Math.floor(Math.random() * 1000),
        ts: Date.now(),
        type,
        data: serializeDebugData(data),
      };
      const events = [next, ...state.events].slice(0, MAX_EVENTS);
      return { events };
    }),
  clearEvents: () =>
    set({
      events: [],
      latestSttOutput: null,
      latestTtsOutput: null,
    }),
}));

export function addResumeDebugEvent(type: string, data?: unknown): void {
  const state = useResumeDebugStore.getState();
  if (!state.enabled) {
    return;
  }
  state.addEvent(type, data);
}
